import { Cargo } from './../models/cargo.model';
import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { Voto } from './../models/voto.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Candidato } from '../models/candidato.model';
import { CandidatoVoto } from '../models/candidatovoto.model';

@Injectable({
  providedIn: 'root'
})
export class VotoService {
  configHeader: any;

  constructor(
    private http: HttpClient
  ) { }

  public save(votos: CandidatoVoto[], token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post(`${environment.url_api}/votos/realizar-votos`, votos, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    })
  }

  public saveVotoNulo(idCargo: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post(`${environment.url_api}/votos/nulo?idCargo=${idCargo}`, {}, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    })
  }

  public saveVotosEmBrancoGeral(idCargo: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post(`${environment.url_api}/votos/brancos?idCargo=${idCargo}`, {}, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    })
  }

  public getByIdEleicao(idEleicao: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get(`${environment.url_api}/votos/by-eleicao?idEleicao=${idEleicao}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    })
  }
}
